import { render, staticRenderFns } from "./SithMesInventoryMaterialDispatchingList.vue?vue&type=template&id=64e5d288&"
import script from "./SithMesInventoryMaterialDispatchingList.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryMaterialDispatchingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports